import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  MenuItem,
  FormHelperText
} from '@mui/material';

const ArchiveBoardDialog = ({
  open,
  onClose,
  onArchive,
  currentBoardId,
  boards,
  targetBoardId,
  setTargetBoardId,
  targetColumnId,
  setTargetColumnId,
  setSelectedTargetBoard,
  targetBoardData
}) => {
  const [errors, setErrors] = useState({ board: false, column: false });

  const handleArchive = () => {
    const newErrors = {
      board: !targetBoardId,
      column: targetBoardId && targetBoardId !== 'backlog' && !targetColumnId
    };
    
    setErrors(newErrors);
    
    if (!newErrors.board && !newErrors.column) {
      onArchive();
      setErrors({ board: false, column: false });
    }
  };

  const handleClose = () => {
    setErrors({ board: false, column: false });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Archive Board</DialogTitle>
      <DialogContent>
        <Typography sx={{ mb: 3, mt: 1 }}>
          Where should incomplete tasks be moved?
        </Typography>
        <TextField
          select
          fullWidth
          label="Move tasks to"
          value={targetBoardId}
          onChange={(e) => {
            setTargetBoardId(e.target.value);
            setTargetColumnId('');
            setSelectedTargetBoard(e.target.value === 'backlog' ? null : e.target.value);
            setErrors({ ...errors, board: false });
          }}
          error={errors.board}
          helperText={errors.board ? 'Please select a destination' : ''}
          sx={{ mb: 2 }}
        >
          <MenuItem value="">Select destination</MenuItem>
          <MenuItem value="backlog">Backlog</MenuItem>
          {boards?.filter(b => b.id.toString() !== currentBoardId).map(board => (
            <MenuItem key={board.id} value={board.id}>{board.name}</MenuItem>
          ))}
        </TextField>
        {targetBoardId && targetBoardId !== 'backlog' && (
          <TextField
            select
            fullWidth
            label="Select column"
            value={targetColumnId}
            onChange={(e) => {
              setTargetColumnId(e.target.value);
              setErrors({ ...errors, column: false });
            }}
            error={errors.column}
            helperText={errors.column ? 'Please select a column' : ''}
          >
            <MenuItem value="">Select column</MenuItem>
            {targetBoardData?.board?.board_columns?.map(column => (
              <MenuItem key={column.id} value={column.id}>{column.name}</MenuItem>
            ))}
          </TextField>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleArchive} color="warning" variant="contained">Archive</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveBoardDialog;
